import React from 'react';

const MenuLeftWalletIcon = ({ color = '#6C6C6C' }) => (
  <svg width="20" height="19" viewBox="0 0 90 86" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.8625 60.15C28.8625 58.6381 30.0881 57.4125 31.6 57.4125H46.2C47.7119 57.4125 48.9375 58.6381 48.9375 60.15C48.9375 61.6619 47.7119 62.8875 46.2 62.8875H31.6C30.0881 62.8875 28.8625 61.6619 28.8625 60.15Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.6 27.3C23.5366 27.3 17 33.8366 17 41.9V71.1C17 79.1634 23.5366 85.7 31.6 85.7H75.4C83.4634 85.7 90 79.1634 90 71.1V41.9C90 33.8366 83.4634 27.3 75.4 27.3H31.6ZM75.4 32.775H31.6C26.5604 32.775 22.475 36.8604 22.475 41.9V42.8125H84.525V41.9C84.525 36.8604 80.4396 32.775 75.4 32.775ZM84.525 48.2875H22.475V71.1C22.475 76.1396 26.5604 80.225 31.6 80.225H75.4C80.4396 80.225 84.525 76.1396 84.525 71.1V48.2875Z"
      fill={color}
    />
    <path
      d="M58.1297 8.62754L15.4588 18.5086C10.5491 19.6455 7.49064 24.5472 8.62754 29.4569L8.8334 30.3459L17.5 28.299C15.5157 30.5614 14.5699 31.9866 13.3101 34.9291L10.0685 35.6797L12.0343 44.1687L12.0343 64.0663C11.0441 62.6132 10.3016 60.9554 9.88104 59.1393L3.29368 30.692C1.47463 22.8365 6.36814 14.9938 14.2236 13.1747L56.8945 3.29368C64.75 1.47463 72.5928 6.36814 74.4118 14.2236L76.2863 22.3183L70.6664 22.3183L70.519 21.6816L67.7692 22.3183L43.5 22.3183L69.2838 16.3477L69.078 15.4588C67.9411 10.5491 63.0393 7.49063 58.1297 8.62754Z"
      fill={color}
    />
  </svg>
);

export default MenuLeftWalletIcon;
